// Render a finding's title / description / evidence-note labels in the current
// language from the findingContent locale bundle, using the finding's stored
// i18n {key, params, evidence:[{key,params}]}. Falls back to the finding's
// stored English strings when no key/translation exists (legacy / ExposIQ).

const interp = (str, params = {}) =>
  String(str).replace(/\{\{(\w+)\}\}/g, (_, k) => (params[k] !== undefined && params[k] !== null ? params[k] : ''));

const getType = (translations, key) => translations?.findingContent?.types?.[key];
const labels = (translations) => translations?.findingContent?.labels || {};
const disclaimers = (translations) => translations?.findingContent?.disclaimer || {};
const evLabels = (translations) => translations?.findingContent?.evidence || {};

// Localised title (falls back to stored finding.title)
export function findingTitle(finding, translations) {
  const t = finding?.i18n?.key && getType(translations, finding.i18n.key);
  if (!t?.title) return finding?.title || '';
  return interp(t.title, finding.i18n.params);
}

// Localised full description: base + Why/Risk sections + any appended disclaimers.
export function findingDescription(finding, translations) {
  const key = finding?.i18n?.key;
  const t = key && getType(translations, key);
  if (!t) return finding?.description || '';
  const p = finding.i18n.params || {};
  const L = labels(translations);
  const parts = [];
  if (t.desc) parts.push(interp(t.desc, p));
  if (t.why) parts.push(`${L.why || 'Why it matters'}: ${interp(t.why, p)}`);
  if (t.risk) parts.push(`${L.risk || 'Risk'}: ${interp(t.risk, p)}`);
  // Appended disclaimers (retire.js / ServiceNow) referenced by key in i18n.disclaimers
  for (const dk of (finding.i18n.disclaimers || [])) {
    const d = disclaimers(translations)[dk];
    if (d) parts.push(interp(d, p));
  }
  return parts.join('\n\n');
}

export function findingRemediation(finding, translations) {
  const t = finding?.i18n?.key && getType(translations, finding.i18n.key);
  if (!t?.remediation) return finding?.remediation || '';
  return interp(t.remediation, finding.i18n.params);
}

// Localise an evidence note's title (content stays as-is). Note may carry its own
// {labelKey, params}; otherwise fall back to its stored title.
export function evidenceTitle(note, translations) {
  if (note?.labelKey) {
    const tpl = evLabels(translations)[note.labelKey];
    if (tpl) return interp(tpl, note.params || {});
  }
  return note?.title || '';
}
